
import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Country } from './types';
import { SocialPlatform } from '@/types/socialPlatform';
import { VideoConfig } from '@/types/videoConfig';

export const useCountryFetching = () => {
  const [availableCountries, setAvailableCountries] = useState<Country[]>([]);

  const fetchAvailableCountries = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('countries')
        .select('*')
        .order('name');
          
      if (error) throw error;
      
      // Cast social_media to SocialPlatform[] and featured_video to VideoConfig to maintain type safety
      const typedData = data.map(country => ({
        ...country,
        social_media: (country.social_media || []) as unknown as SocialPlatform[],
        featured_video: country.featured_video ? country.featured_video as unknown as VideoConfig : null
      })) as Country[];
      
      setAvailableCountries(typedData);
      return typedData;
    } catch (error) {
      console.error("Error fetching available countries:", error);
      return [];
    }
  }, []);

  useEffect(() => {
    const loadCountries = async () => {
      await fetchAvailableCountries();
    };

    loadCountries();
  }, [fetchAvailableCountries]);

  return { availableCountries, fetchAvailableCountries };
};
